module.exports = __webpack_public_path__ + "static/media/masters_thesis4.7028cdc6.webp";